import { request } from './http'

export interface StoryBranch {
  id: string
  name: string
  parent_branch_id?: string | null
  fork_chapter: number
  direction?: string | null
  is_active: boolean
  created_at?: string | null
}

export interface ForkBranchInput {
  project_id: string
  from_branch_id: string
  name: string
  from_chapter: number
  direction?: string
}

export interface PromoteBranchResponse {
  ok: boolean
  promoted_branch_id: string
  archived_branch_id: string
}

export const branchApi = {
  list: (projectId: string): Promise<StoryBranch[]> =>
    request<{ branches: StoryBranch[] } | StoryBranch[]>(
      `/v1/branches?project_id=${encodeURIComponent(projectId)}`,
    ).then((data) => (Array.isArray(data) ? data : (data.branches ?? []))),

  getBranches: (projectId: string): Promise<StoryBranch[]> => branchApi.list(projectId),

  fork: (body: ForkBranchInput): Promise<StoryBranch> =>
    request<StoryBranch>(`/v1/branches/fork`, { method: 'POST', body }),

  switch: (projectId: string, branchId: string): Promise<unknown> =>
    request(`/v1/branches/switch`, {
      method: 'POST',
      body: { project_id: projectId, branch_id: branchId },
    }),

  promote: (projectId: string, branchId: string): Promise<PromoteBranchResponse> =>
    request<PromoteBranchResponse>(
      `/v1/projects/${encodeURIComponent(projectId)}/branches/${encodeURIComponent(branchId)}/promote`,
      { method: 'POST' },
    ),
}
